import React, { useEffect, useRef } from "react";

// Bare checkbox with a real DOM `indeterminate` state, which has no HTML
// attribute - only settable imperatively via a ref. Used for both the
// "Select all" header checkbox (indeterminate when some-but-not-all rows are
// selected) and the plain per-row checkboxes (indeterminate always false)
// across every table with bulk-select, so all of them share one focus ring /
// sizing instead of four slightly different ad-hoc <input>s.
const TriStateCheckbox = ({ checked, indeterminate = false, onChange, disabled = false, label }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <input
      ref={ref}
      type="checkbox"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      aria-label={label}
      className="h-[15px] w-[15px] accent-[var(--accent)] cursor-pointer disabled:cursor-not-allowed disabled:opacity-50"
    />
  );
};

export default TriStateCheckbox;
